import React, { useEffect, useState, useCallback } from 'react';
import api from '../services/api';
import ProfileForm from '../components/ProfileForm';
import TableFilter from '../components/TableFilter';
import ActionButtons from '../components/ActionButtons';

interface Group {
  id: number;
  name: string;
  permissions: number[];
}

const ProfilesPage: React.FC = () => {
  const [profiles, setProfiles] = useState<Group[]>([]);
  const [filteredProfiles, setFilteredProfiles] = useState<Group[]>([]);
  const [showForm, setShowForm] = useState(false);
  const [editingProfile, setEditingProfile] = useState<Group | null>(null);

  const fetchProfiles = useCallback(async () => {
    try {
      const response = await api.get('/groups/');
      setProfiles(response.data);
      setFilteredProfiles(response.data);
    } catch (error) {
      console.error("Error fetching profiles", error);
    }
  }, []);

  useEffect(() => {
    fetchProfiles();
  }, [fetchProfiles]);

  const handleFilter = (filters: { [key: string]: string }) => {
    let result = profiles;

    if (filters.name) {
      result = result.filter(p => p.name.toLowerCase().includes(filters.name.toLowerCase()));
    }

    setFilteredProfiles(result);
  };

  const handleSuccess = () => {
    setShowForm(false);
    setEditingProfile(null);
    fetchProfiles();
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingProfile(null);
  };

  const handleEdit = (profile: Group) => {
    setEditingProfile(profile);
    setShowForm(true);
  };

  const handleDelete = async (id: number) => {
    if (window.confirm('Tem certeza que deseja excluir este perfil?')) {
      try {
        await api.delete(`/groups/${id}/`);
        fetchProfiles();
      } catch (error) {
        console.error("Error deleting profile", error);
        alert('Erro ao excluir perfil.');
      }
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
          <h1>Perfis de Acesso</h1>
          <p style={{ color: 'var(--text-secondary)', margin: 0 }}>Configure os grupos e permissões do sistema</p>
        </div>
        {!showForm && (
          <button className="btn" onClick={() => setShowForm(true)}>
            + Novo Perfil
          </button>
        )}
      </div>

      {showForm ? (
        <div style={{ marginBottom: '30px' }}>
          <ProfileForm
            onSuccess={handleSuccess}
            onCancel={handleCancel}
            profileToEdit={editingProfile}
          />
        </div>
      ) : (
        <TableFilter
          filters={[
            { key: 'name', label: 'Nome do Perfil' }
          ]}
          onFilter={handleFilter}
        />
      )}

      <div className="card" style={{ overflowX: 'auto' }}>
        <table>
          <thead>
            <tr>
              <th>Nome do Perfil</th>
              <th>Permissões</th>
              <th style={{ textAlign: 'right' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {filteredProfiles.length === 0 ? (
              <tr>
                <td colSpan={3} style={{ textAlign: 'center', padding: '30px', color: 'var(--text-light)' }}>
                  Nenhum perfil encontrado.
                </td>
              </tr>
            ) : (
              filteredProfiles.map((profile) => (
                <tr key={profile.id}>
                  <td style={{ fontWeight: '500' }}>{profile.name}</td>
                  <td>
                    <span className="badge badge-info">{profile.permissions.length} permissões</span>
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <ActionButtons
                      onEdit={() => handleEdit(profile)}
                      onDelete={() => handleDelete(profile.id)}
                      deletePermission="delete_group"
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProfilesPage;
